import React, { useEffect, useContext } from 'react';
import { Button, Grid, Paper, Typography, Box } from '@mui/material';
import IntlMessages from 'lngProvider/IntlMessages';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import { useHistory } from 'react-router-dom';
import { AuthThemeContext } from 'themes/AuthThemeProvider';
import registerService from 'services/RegisterService';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';
import useQueryParams from 'hooks/useQueryParams';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root,
            '& .register-success': {
                maxWidth: '576px'
            },
            '& .margin-top-2': {
                marginTop: '0.5rem'
            },
            '& .margin-top-4': {
                marginTop: '1.5rem'
            }
        };
    });

const Register = () => {
    document.title = "3M - Registered!";
    const { setAppTheme } = useContext(AuthThemeContext);
    const history = useHistory();
    const { getQueryParamByName } = useQueryParams();

    useEffect(() => {
        const fetchData = async () => {
            const returnUrl = getQueryParamByName('ReturnUrl');
            var config = await registerService.getRegisterSettings(returnUrl);
            setAppTheme(config.themeName);
        };

        fetchData();

    }, [setAppTheme, getQueryParamByName]);

    const handleSignInClick = () => {
        var queryString = window.location.search;
        history.push(`/app/login${queryString}`);
    }

    return (
        <section>
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center" direction="column">
                        <Grid item xs={12}>
                            <StyledPaper>
                                <Grid className="register-success" container alignItems="center" justifyContent="center" direction="column" spacing={4}>
                                    <Grid item xs={12}>

                                        <Grid item className="margin-top-4">
                                            <div className="text-success text-center"> <Typography variant="h1"><CheckCircleTwoToneIcon fontSize="inherit" color="inherit" /></Typography></div>
                                        </Grid>

                                        <Grid item className="margin-top-4">
                                            <Grid container justifyContent="center" alignItems="center">
                                                <Typography variant="h4"><IntlMessages id="registerSuccess.title" /></Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} className="margin-top-4">
                                            <Grid container justifyContent="center" alignItems="center">
                                                
                                                <Typography variant="subtitle2"><Box component="span" fontWeight='fontWeightBold'><IntlMessages id="registerSuccess.header" /> </Box></Typography>
                                               
                                            </Grid>
                                        </Grid>

                                        <Grid item className="margin-top-4">
                                            <Grid container justifyContent="center" alignItems="center">
                                                <Typography variant="subtitle2">
                                                    <IntlMessages id="registerSuccess.missingEmail" />
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button color="primary" variant="contained" onClick={handleSignInClick}>
                                            <IntlMessages id="registerSuccess.signIn" />
                                        </Button>
                                    </Grid>

                                </Grid>
                            </StyledPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </section>
    );
};

export default Register;